import Cropper from 'cropperjs';
import { imageToolbarstyle } from './style';
import { Modal, InputNumber } from '@tinper/next-ui'
import React, { useState, useEffect } from "react";
import i18n from "../i18n";

const SizeInput = (props) => {
  const itemStyle = { display: 'flex', flexDirection: 'column', justifyContent: 'space-between' };
  const ratio = props.height / props.width;
  const { changeSize, langMap } = props;

  const [width, setWidth] = useState(props.width);
  const [height, setHeight] = useState(props.height);

  useEffect(() => {
    changeSize(width, height);
  }, [width, height]);

  return <div style={{ display: 'flex', height: 50, columnGap: 20 }}>
    <div style={itemStyle}>
      {langMap.width}
      <InputNumber
        autoFix
        min={1}
        style={{ width: 150 }}
        value={width}
        onChange={(value) => {
          setWidth(value);
          setHeight(Math.round(value * ratio));
        }}
      />
    </div>
    <div style={itemStyle}>
      {langMap.height}
      <InputNumber
        min={1}
        style={{ width: 150 }}
        value={height}
        onChange={(value) => {
          setHeight(value)
          setWidth(Math.round(value / ratio));
        }}
      />
    </div>
  </div>
}

export const setImageToolbar = (editor, locale) => {
  // console.log('editer', editor);

  editor.on('init', () => {
    editor.dom.addStyle(imageToolbarstyle);
  });

  const langMap = i18n[locale || 'zh_cn'] || {};

  const getSelectedImage = (editor, onlyImg = true) => {
    const imgElm = editor.selection.getNode();
    const figureElm = editor.dom.getParent(imgElm, 'figure.image');
    if (figureElm) {
      return onlyImg ? editor.dom.select('img', figureElm)[0] : figureElm;
    }
    if (imgElm && (imgElm.nodeName !== 'IMG')) {
      return null;
    }
    return imgElm;
  };

  const wrapInContainer = (image) => {
    const ImageContainer = editor.dom.create('div', { class: 'image-crop-container' });
    const imgStyle = editor.dom.parseStyle(image.getAttribute('style'));
    ImageContainer.style.display = 'inline-block';
    ImageContainer.style.width = image.width + 'px';
    ImageContainer.style.height = image.height + 'px';
    for (const key in imgStyle) {
      ImageContainer.style[key] = imgStyle[key];
    }
    editor.dom.insertAfter(ImageContainer, image);
    ImageContainer.appendChild(image);
  };

  const unwrapFromContainer = (image) => {
    const parentElement = image.parentNode;
    if (!parentElement?.classList.contains('image-crop-container')) return;
    const grandParentElement = parentElement.parentNode;
    grandParentElement.insertBefore(image, parentElement);
    parentElement.remove();
  };

  // 注册svg图标
  editor.ui.registry.addIcon('image-rotation', '<svg height="16" width="16" style="transform: rotateY(180deg)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g fill="none" fill-rule="evenodd"><rect stroke="currentColor" stroke-width="20" x="26.127" y="102" width="163.38" height="116" rx="20"></rect><path d="M124.295 69.037 95.058 45.322a3 3 0 0 1 0-4.66l29.237-23.715a3 3 0 0 1 4.89 2.33v47.43a3 3 0 0 1-4.89 2.33Z" fill="currentColor"></path><path d="M127.5 43.003c13.398 0 42.885-2.143 65.723 9.607C216.062 64.36 228 88.605 229.4 109.001" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>');
  editor.ui.registry.addIcon('image-crop', '<svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g fill="currentColor" fill-rule="nonzero"><path d="M72.74 20c5.832 0 10.578 4.735 10.737 10.637l.004.306V161.17c0 5.941 4.648 10.777 10.44 10.939l.301.004H225.26c5.932 0 10.741 4.9 10.741 10.944 0 5.941-4.647 10.777-10.44 10.939l-.3.004H94.221c-17.618 0-31.933-14.406-32.218-32.287L62 161.17V30.943C62 24.9 66.809 20 72.74 20Z"></path><path d="M183.39 237c-5.76 0-10.448-4.676-10.605-10.505l-.005-.302V95.423c0-5.868-4.59-10.644-10.312-10.804l-.297-.004H30.61c-5.86 0-10.61-4.839-10.61-10.808 0-5.867 4.59-10.643 10.313-10.803L30.61 63h131.56c17.404 0 31.545 14.227 31.826 31.886l.004.536v130.77c0 5.97-4.75 10.808-10.61 10.808Z"></path></g></svg>');
  editor.ui.registry.addIcon('image-size', '<svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path d="M2.625 13.25A1.875 1.875 0 0 1 .75 11.375v-8.75C.75 1.589 1.59.75 2.625.75h2.5C6.161.75 7 1.59 7 2.625v3.75c0 .345.28.625.625.625h3.75c1.025 0 1.858.823 1.875 1.844v2.531c0 1.036-.84 1.875-1.875 1.875ZM5.125 2h-2.5A.625.625 0 0 0 2 2.625V3.75h1.25a.563.563 0 0 1 0 1.125H2v1.75h2.063a.563.563 0 0 1 0 1.125H2V9.5h1.25a.562.562 0 1 1 0 1.125H2v.75c0 .314.231.574.533.618l.092.007h3.187v-1.75a.562.562 0 1 1 1.125 0V12h1.875v-1.063a.562.562 0 1 1 1.126 0L9.937 12h1.438a.625.625 0 0 0 .618-.533l.007-.092v-2.5a.625.625 0 0 0-.625-.625H7c-.69 0-1.25-.56-1.25-1.25V2.625A.625.625 0 0 0 5.125 2Z" fill="currentColor" fill-rule="nonzero"></path></svg>');
  editor.ui.registry.addIcon('image-title', '<svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g fill="none" fill-rule="evenodd"><rect stroke="currentColor" stroke-width="20" x="38" y="38" width="180" height="84" rx="20"></rect><rect fill="currentColor" x="28" y="158" width="200" height="20" rx="10"></rect><rect fill="currentColor" x="28" y="208" width="120" height="20" rx="10"></rect></g></svg>');
  editor.ui.registry.addIcon('image-style', '<svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path d="M8.563.75c.986 0 1.794.761 1.869 1.728l.002.084h.941c.986 0 1.795.762 1.87 1.729l.005.146v6.938c0 .986-.761 1.795-1.728 1.87l-.147.005H4.437a1.875 1.875 0 0 1-1.869-1.728l-.006-.147v-.941l-.084-.002A1.875 1.875 0 0 1 .756 8.709L.75 8.563V2.625c0-.986.761-1.795 1.728-1.87L2.625.75h5.938Zm.398 9.645L10.565 12l.81.001a.625.625 0 0 0 .618-.533l.007-.092v-.38l-1.707-1.708a1.879 1.879 0 0 1-1.332 1.108Zm-4.268.042h-.881v.938c0 .314.232.574.533.618l.093.007h1.817l-1.562-1.563Zm3.249 0H5.753L7.316 12h2.19l-1.564-1.563Zm2.495-4.255v2.189L12 9.934v-2.19l-1.563-1.562ZM8.563 2H2.625a.625.625 0 0 0-.618.533L2 2.625v5.938c0 .313.231.573.533.618l.03.002.062.005 1.877-.001h4.061a.625.625 0 0 0 .618-.532l.007-.092V2.625A.625.625 0 0 0 8.562 2Zm1.874 1.812v1.309L12 6.684V4.437a.625.625 0 0 0-.533-.618l-.092-.006-.938-.001Z" fill="currentColor" fill-rule="nonzero"></path></svg>');
  editor.ui.registry.addIcon('image-fullscreen', '<svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="design-iconfont"><path d="M1,5.00487317 L1,2 C1,1.44771525 1.44771525,1 2,1 L5.00789824,1 M11.0033229,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,5.00380313 M15,11.0042627 L15,14 C15,14.5522847 14.5522847,15 14,15 L11.0040944,15 M5.01036435,15 L2,15 C1.44771525,15 1,14.5522847 1,14 L1,11.0076353" stroke="#4B5563" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>');

  // 图片旋转
  editor.ui.registry.addButton("image-rotation", {
    icon: 'image-rotation',
    onAction: function (a) {
      const image = getSelectedImage(editor);
      // rotateImg(image);
      let currentRotation = 0;
      const rotationMatch = image.style.transform.match(/rotate\(([\d.]+)deg\)/);
      if (rotationMatch) {
        currentRotation = parseFloat(rotationMatch[1]);
      }
      currentRotation = (currentRotation + 180) % 360;
      image.style.transform = `rotate(${currentRotation}deg)`;
      editor.execCommand('mceUpdateImage', false, {});
    }
  });

  // 图片裁剪
  editor.ui.registry.addButton("image-crop", {
    icon: 'image-crop',
    onAction: function (a) {
      const image = getSelectedImage(editor);
      wrapInContainer(image);
      let cropper = new Cropper(image, {
        dragMode: false,
        viewMode: 1,
        center: false,
        guides: false,
        background: false,
        zoomable: false,
        autoCropArea: 0.5
      });

      editor.on('click', function (e) {
        const target = e.target;
        if (cropper && editor.dom.getParent(target, '.image-crop-container') === null) {
          const cropBoxData = cropper.getCropBoxData();
          const url = cropper.getCroppedCanvas({ fillColor: '#fff' }).toDataURL('image/png');
          image.src = url;
          image.width = cropBoxData.width;
          image.height = cropBoxData.height;
          cropper.destroy();
          cropper = null;
          unwrapFromContainer(image);
          editor.execCommand('mceUpdateImage', false, {});
        }
      });
    }
  });

  // 图片尺寸
  editor.ui.registry.addButton("image-size", {
    icon: 'image-size',
    text: langMap.imgSize,
    onAction: function (a) {
      const image = getSelectedImage(editor);
      const newSize = {};
      const changeSize = (w, h) => {
        console.log(w, '---', h)
        newSize.width = w;
        newSize.height = h;
      }

      Modal.confirm({
        icon: null,
        title: null,
        width: 445,
        content: <SizeInput width={image.width} height={image.height} changeSize={changeSize} langMap={langMap} />,
        onOk: () => {
          if (newSize.width && newSize.height) {
            image.width = parseInt(newSize.width);
            image.height = parseInt(newSize.height);
            editor.execCommand('mceUpdateImage', false, {});
          }
        }
      });
    }
  });

  // 图片描述
  editor.ui.registry.addButton("image-title", {
    icon: 'image-title',
    text: langMap.imgTitle,
    onAction: function () {
      const image = getSelectedImage(editor, false);
      if (image.nodeName === 'FIGURE') {
        editor.execCommand('mceUpdateImage', false, { caption: false });
      } else {
        editor.execCommand('mceUpdateImage', false, { caption: true });
      }
    }
  });

  // 图片样式
  let imageStyleType = 1;
  editor.ui.registry.addMenuButton("image-style", {
    tooltip: 'Image Style',
    icon: 'image-style',
    text: langMap.imgStyle,
    fetch: function (callback) {
      const image = getSelectedImage(editor);
      imageStyleType = image.style.borderStyle ? 2 : image.style.boxShadow ? 3 : 1;
      const items = [
        {
          type: 'togglemenuitem',
          text: langMap.noStyle,
          onAction: function () {
            imageStyleType = 1;
            editor.execCommand('mceUpdateImage', false, { borderStyle: '' });
            image.style.boxShadow = '';
          },
          onSetup: function (api) {
            api.setActive(imageStyleType === 1);
            return function () { };
          }
        },
        {
          type: 'togglemenuitem',
          text: langMap.imgStroke,
          onAction: function () {
            imageStyleType = 2;
            editor.execCommand('mceUpdateImage', false, { borderStyle: 'groove' });
            image.style.boxShadow = '';
          },
          onSetup: function (api) {
            api.setActive(imageStyleType === 2);
            return function () { };
          }
        },
        {
          type: 'togglemenuitem',
          text: langMap.imgShadow,
          onAction: function () {
            imageStyleType = 3;
            editor.execCommand('mceUpdateImage', false, { borderStyle: '' });
            image.style.boxShadow = "0 0 0 2px #0091ff";
          },
          onSetup: function (api) {
            api.setActive(imageStyleType === 3);
            return function () { };
          }
        }
      ];
      callback(items);
    }
  });

  // 图片全屏
  const goToFullScreen = (element) => {
    element = element || document.body;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullScreen();
    }
  };
  editor.ui.registry.addButton("image-fullscreen", {
    icon: 'image-fullscreen',
    onAction: function () {
      const image = getSelectedImage(editor);
      goToFullScreen(image);
    }
  });

  // 图片对齐方式
  editor.ui.registry.addMenuButton('image-alignment', {
    icon: 'align-left',
    tooltip: 'Image Alignment',
    fetch: function (callback) {
      const image = getSelectedImage(editor);
      const imgContainer = editor.dom.getParent(image, 'p')
      const alignToolbarButtons = [
        {
          type: 'togglemenuitem',
          icon: 'align-left',
          onAction: () => {
            if (imgContainer) {
              imgContainer.style.textAlign = 'left';
              editor.execCommand('mceUpdateImage', false, {});
            } else {
              editor.execCommand('JustifyLeft');
            }
          },
          onSetup: (api) => { api.setActive(editor.formatter.match('alignleft')); }
        },
        {
          type: 'togglemenuitem',
          icon: 'align-center',
          onAction: () => {
            if (imgContainer) {
              imgContainer.style.textAlign = 'center';
              editor.execCommand('mceUpdateImage', false, {});
            } else {
              editor.execCommand('JustifyCenter');
            }
          },
          onSetup: (api) => { api.setActive(editor.formatter.match('aligncenter')); }
        },
        {
          type: 'togglemenuitem',
          icon: 'align-right',
          onAction: () => {
            if (imgContainer) {
              imgContainer.style.textAlign = 'right';
              editor.execCommand('mceUpdateImage', false, {});
            } else {
              editor.execCommand('JustifyRight');
            }
          },
          onSetup: (api) => { api.setActive(editor.formatter.match('alignright')); }
        }
      ];
      callback(alignToolbarButtons);
    }
  });

  // 注册图片工具栏
  editor.ui.registry.addContextToolbar('imageselection', {
    // eslint-disable-next-line no-undef
    predicate: (node) => node.nodeName === 'IMG' || (node.nodeName === 'FIGURE' && /image/i.test(node.className)),
    items: 'image-rotation image-crop image-size | image-title image-alignment image-style | image-fullscreen',
    position: 'node',
    scope: 'node'
  });
}

// eslint-disable-next-line no-unused-vars
function base64ToBlobUrl (base64ImageString) {
  const parts = base64ImageString.split(',');
  const mimeString = parts[0].match(/data:([^;]+)/)[1];
  const base64Data = parts[1];
  const binaryData = window.atob(base64Data);

  const arrayBufferView = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    arrayBufferView[i] = binaryData.charCodeAt(i);
  }

  const blob = new Blob([arrayBufferView], { type: mimeString });
  const blobUrl = URL.createObjectURL(blob);

  return blobUrl;
}

// eslint-disable-next-line no-unused-vars
function rotateImg (imgElm, rotate = 90) {
  const { width, height, src } = imgElm;
  // eslint-disable-next-line no-undef
  const img = new Image();
  img.src = src;
  img.setAttribute('crossOrigin', 'Anonymous');
  img.onload = () => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = img.height;
    canvas.height = img.width;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.translate(-canvas.width / 2, -canvas.height / 2);
    context.drawImage(img, canvas.width / 2 - img.width / 2, canvas.height / 2 - img.height / 2, img.width, img.height);
    context.restore();
    const base64 = canvas.toDataURL();
    // imgElm.src = base64ToBlobUrl(base64);
    imgElm.src = base64;
    imgElm.width = height;
    imgElm.height = width;
  }
}